import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast_popup } from '../../utils/toast';
import {
    fetchTrackingRecords,
    exportTrackingData,
} from '../../apis/tracking-reports.api';
import moment from 'moment';

const initialState = {
    records: [],
    loading: false,
    pageNo: 0,
    count: 0,
    keywords: '',
    limit: 15,
    sortBy: -1,
    sortField: 'createdAt',
    content_type: '',
    start_date: '',
    end_date: '',
    big_ref_no: '',
    customer_email: '',
    user_plan: '',
};

const changeTrackingParameter = createAsyncThunk(
    'tracking-report/changeTrackingParameter',
    async (state, action) => {
        return state;
    },
);

const fetchTrackingRecordsAction = createAsyncThunk(
    'tracking-report/fetchTrackingRecords',
    async (state, action) => {
        try {
            var response = await fetchTrackingRecords(state);
            var result = response.data;

            if (!result.success) {
                throw new Error(result.message || 'Something went wrong!');
            }
            return result.result;
        } catch (err) {
            throw new Error(err?.response?.data?.message || err.message);
        }
    },
);

const exportTrackingDataAction = createAsyncThunk(
    'tracking-report/exportTrackingData',
    async (state, action) => {
        try {
            var response = await exportTrackingData(state);
            var result = response.data;

            if (!result.success) {
                throw new Error(result.message || 'Something went wrong!');
            }
            return result.result;
        } catch (err) {
            throw new Error(err?.response?.data?.message || err.message);
        }
    },
);

export const trackingReportSlice = createSlice({
    name: 'tracking-report',
    initialState,
    reducers: {},
    extraReducers: {
        [changeTrackingParameter.pending]: (state, action) => {
            // state.loading = true;
        },
        [changeTrackingParameter.fulfilled]: (state, action) => {
            const {
                pageNo,
                limit,
                sortBy,
                sortField,
                keywords,
                count,
                content_type,
                start_date,
                end_date,
                big_ref_no,
                customer_email,
                user_plan,
            } = action.payload;

            if (pageNo !== undefined && pageNo !== null) state.pageNo = pageNo;
            if (limit !== undefined && limit !== null) state.limit = limit;
            if (sortBy !== undefined && sortBy !== null) state.sortBy = sortBy;
            if (sortField !== undefined && sortField !== null)
                state.sortField = sortField;
            if (keywords !== undefined && keywords !== null) state.keywords = keywords;
            if (count !== undefined && count !== null) state.count = count;
            if (content_type !== undefined && content_type !== null)
                state.content_type = content_type;
            if (start_date !== undefined && start_date !== null)
                state.start_date = start_date;
            if (end_date !== undefined && end_date !== null) state.end_date = end_date;
            if (big_ref_no !== undefined && big_ref_no !== null)
                state.big_ref_no = big_ref_no;
            if (customer_email !== undefined && customer_email !== null)
                state.customer_email = customer_email;
            if (user_plan !== undefined && user_plan !== null)
                state.user_plan = user_plan;
        },
        [changeTrackingParameter.rejected]: (state, action) => {
            toast_popup(action.error.message, 'error');
            state.loading = false;
        },
        [fetchTrackingRecordsAction.pending]: (state, action) => {
            state.loading = true;
        },
        [fetchTrackingRecordsAction.fulfilled]: (state, action) => {
            state.loading = false;
            state.records = action.payload.result.map((p) => ({
                ...p,
                _id: p._id,
                key: p._id,
            }));

            state.pageNo = Number(action.payload.pageNo || 0);
            state.limit = Number(action.payload.limit || 15);
            state.sortBy = Number(action.payload.sortBy || -1);
            state.sortField = action.payload.sortField || 'createdAt';
            state.count = Number(action.payload.count || 0);
        },
        [fetchTrackingRecordsAction.rejected]: (state, action) => {
            toast_popup(action.error.message, 'error');
            state.loading = false;
        },
        [exportTrackingDataAction.fulfilled]: (state, action) => {
            toast_popup('Tracking data exported successfully', 'success');
            // Handle file download
            if (action.payload.download_url) {
                const link = document.createElement('a');
                link.href = action.payload.download_url;
                link.download = action.payload.filename || 'tracking_report.csv';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        },
        [exportTrackingDataAction.rejected]: (state, action) => {
            toast_popup('Failed to export tracking data', 'error');
        },
    },
});

export { changeTrackingParameter, fetchTrackingRecordsAction, exportTrackingDataAction };
export default trackingReportSlice.reducer;
